import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import BannerAside from '../components/BannerAside';

export default function AccountLayout({ ...props }: PropsWithChildren<any>) {
  return (
    <>      
      <div className="grid grid-cols-12 min-h-full h-screen">
        <BannerAside />
        <div className='col-span-7 px-[50px] py-[70px] flex justify-center bg-[#FEF7FF]'>
            {props.children}
        </div>
      </div>      
    </>
  )
}
